import type { ReactNode } from 'react';

interface IconCircularProgressBarProps {
  strokeWidth?: number;
  radius?: number;
  percentage?: number;
  color?: string;
  children?: ReactNode;
}

export const IconCircularProgressBar = ({
  strokeWidth = 8,
  radius = 50,
  percentage = 0,
  color = 'black',
  children,
}: IconCircularProgressBarProps) => {
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  const size = radius * 2 + strokeWidth * 2;

  return (
    <span className="relative inline-block" style={{ width: size, height: size }}>
      <svg className="block" height={size} width={size} aria-hidden="true">
        {/* Background Circle */}
        <circle stroke="#E3E3E3" fill="transparent" strokeWidth={strokeWidth} r={radius} cx={radius + strokeWidth} cy={radius + strokeWidth} />
        {/* Progress Circle */}
        <circle
          stroke={color}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          style={{ strokeDashoffset, transition: 'stroke-dashoffset 0.5s ease' }}
          strokeLinecap="round"
          r={radius}
          cx={radius + strokeWidth}
          cy={radius + strokeWidth}
          transform={`rotate(-90 ${radius + strokeWidth} ${radius + strokeWidth})`}
        />
      </svg>

      <span className="absolute inset-0 flex items-center justify-center">{children ?? <span>{percentage}%</span>}</span>
    </span>
  );
};
